import { ListChecks } from 'lucide-react'
import { useState } from 'react'

import { type MultipleSelectedValuesFilter } from 'components/brokers/types'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from 'components/reusable/table/ComboboxMultiSelectFilter'
import { useGetBrokersTasksTaskTypes } from 'utils/web_api'

import FilterManagementDropdown from '../needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../needs_attention/utils'

const TaskTypesFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const { data: taskTypes } = useGetBrokersTasksTaskTypes()

  const taskTypeOptions: ComboboxFilterOption<string>[] | undefined =
    taskTypes?.map((taskType) => ({
      label: taskType.display_name,
      value: taskType.task_type,
    }))

  const filteredOptions = taskTypeOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Task Types', options: filteredOptions || [] }]}
        placeholder='Search task types to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={taskTypeOptions || []}
          noSelectionText='Task Type'
          pluralIdentifier='task types'
        >
          <ListChecks size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default TaskTypesFilter
